import app from "js/legacy-app";

app.directive('blItemStatus', [function () {
    return {
        templateUrl: "components/bike/list/base/bl-item-status.html",
        replace: true,
        transclude: true
    };
}]);